import utils from '../utils/index.js';
import generalConst from './general.js';
import constellations from './constellations.js';
import constelIntroMap from './constelIntroMap.js';

let constels = constellations.slice(0, generalConst.addCount).map(item => {
  item.id = `${item.id}`;
  const latinName = item.latinName;
  // 为星座添加星座图标
  if (latinName) {
    let iconName = latinName;
    if (latinName.includes(' ')) {
      const nameArr = latinName.split(' ');
      iconName = `${nameArr[0]}_${nameArr[1].toLowerCase()}`;
    }

    if (item.raRange) {
      item.raRange = item.raRange.replace(/时/g, 'h').replace(/分/g, 'm');
    }
    if (item.area) {
      item.area = item.area.replace(/km²/g, '平方度');
    }
    if (item.containedStars) {
      item.containedStars = `${item.containedStars}个`;
    }

    try {
      const icon = require(`../assets/images/constels/bigIcon/${iconName}.png`);
      if (icon) {
        item.icon = icon;
      } else {
        item.icon = '';
        throw icon;
      }
    } catch (error) {
      console.log(item.name + '%c 大图标不匹配', "color: blue;", iconName);
    }

    // try {
    //   const smallIcon = require(`../assets/images/constels/smallIcon/img_star_list_${iconName}@2x.png`);
    //   if (smallIcon) {
    //     item.smallIcon = smallIcon;
    //   } else {
    //     item.smallIcon = '';
    //     throw smallIcon;
    //   }
    // } catch (error) {
    //   console.log(item.name + '%c 小图标不匹配', "color: blue;", smallIcon);
    // }
  }
  const convertedStarCoord = convertStarCoord(item);
  return Object.assign(item, convertedStarCoord);
});

// 转换星星的坐标
/**
 * 将星座中的星星坐标从赤经、赤纬、距离转换为笛卡尔坐标 (x, y, z)。
 *
 * @param {Object} constel - 包含星星原始坐标信息的星座对象。
 * @returns {Object} - 包含转换后的坐标数组和星星对象数组的对象。
 * @property {Array} coords - 转换后的笛卡尔坐标数组。
 * @property {Array} starObjArr - 包含星星信息的对象数组。
 */
function convertStarCoord(constel) {
  // 从星座对象中获取星星的原始坐标列表
  const list = constel.starsOrigin;
  // 获取星座的名称
  const name = constel.name;
  // 从通用常量中获取赤经转换系数
  const degree = generalConst.degree;
  // 从通用常量中获取距离转换系数
  const multiple = generalConst.multiple;
  // 用于存储转换后的笛卡尔坐标
  const stars = [];
  // 用于存储转换后的星星对象数组
  const starObjArr = [];

  // 遍历星星列表
  list.forEach((starObj, index) => {
    // 从星星对象中解构出赤经、赤纬和距离
    const [ra, dec, dist] = starObj.position;
    // 使用通用常量中的距离值
    const newDist = generalConst.dist;
    // 存储转换后的赤经、赤纬和距离
    const temp = [ra * degree, dec, newDist * multiple];

    try {
      // 调用工具函数将赤经、赤纬和距离转换为笛卡尔坐标
      const { x, y, z } = utils.convertEquatorialToXYZ.apply(this, temp);
      // 将转换后的笛卡尔坐标添加到 stars 数组中
      stars.push(x, y, z);
      // 计算星星到原点的距离
      const distance = distToOrigin(x, y, z);

      // 创建一个包含星星信息的对象，并将其添加到 starObjArr 数组中
      starObjArr.push({
        // 生成星星的唯一 ID
        id: constel.id + `${index + 1}`.padStart(2, '0'),
        // 星星的名称
        name: starObj.name,
        // 星星的笛卡尔坐标
        position: [x, y, z],
        // 星星的赤经、赤纬和距离
        raDec: [ra, dec, newDist],
        // 星星到原点的距离
        dist: distance
      });
    } catch (error) {
      // 打印错误信息
      console.error(`Error converting coordinates for star ${starObj.name} in constellation ${name}:`, error);
    }
  });

  // 返回包含转换后的坐标数组和星星对象数组的对象
  return {
    coords: stars,
    starObjArr: starObjArr
  };
}

function distToOrigin(x, y, z) {
  return Math.round(Math.sqrt(x*x + y*y + z*z));
}

// 将时角坐标（也称为赤道坐标系中的赤经）转换为XYZ坐标
function equatorialToCartesian(rightAscension, declination) {
  const raRad = this.toRadians(rightAscension);
  const decRad = this.toRadians(declination);

  const x = Math.cos(raRad) * Math.cos(decRad);
  const y = Math.sin(raRad) * Math.cos(decRad);
  const z = Math.sin(decRad);

  return { x, y, z };
}
function toRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

// todo：要删除
// 将时角坐标转换为XYZ坐标
// 赤经：度；赤纬：度；距离，单位是任意长度单位（比如光年）。
function convertEquatorialToXYZ1(rightAscension, declination, distance) {
  // 将时角转换为赤经
  const rightAscensionRad = rightAscension / 180 * Math.PI;

  // 计算XYZ坐标
  const x = Math.cos(rightAscensionRad) * Math.cos(declination / 180 * Math.PI) * distance;
  const y = Math.sin(rightAscensionRad) * Math.cos(declination / 180 * Math.PI) * distance;
  const z = Math.sin(declination / 180 * Math.PI) * distance;

  return { x, y, z };
  // return { x: x, y: z, z: y };
}

export default {
  constels,
  constelIntroMap
};
